import { memo } from "react";

const SendDocument = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_5142_799)">
      <path
        d="M14.3337 1.66699L9.90033 14.3337L7.36699 8.63366L1.66699 6.10033L14.3337 1.66699Z"
        stroke="#141516"
        strokeWidth="1.40351"
        strokeLinejoin="round"
      />
      <path
        d="M14.3339 1.66699L7.36719 8.63366"
        stroke="#141516"
        strokeWidth="1.40351"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_5142_799">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default memo(SendDocument);
